import { AuthenticationState, initialAuthenticationState } from './authentication-state';
import { DashboardState, initialDashboardState } from './dashboard-state';
import { LegalState, initialLegalState } from './legal-state';
import { LocationState } from 'history';
import { NavigationState, initialNavigationState } from './navigation-state';
import { RegistrationState, initialRegistrationState } from './registration-state';
import { UserState, initialUserState } from './user-state';
import { TimelineExportState, initialTimelineExport } from './timeline-export-state';
import { SiganlRConnectionState, initialSiganlRConnection } from './siganlr-connection.state';
import { TrendExportState, initialTrendExport } from './trend-export-state';
import { AlarmAcknowledgementState, initialAlarmAcknowledgement } from './alarm-state';
import { initialSite, SiteState } from './site-state';
import { initialSierraDevice, SierraDeviceState } from './sierra-device-state';
import { initialPxdbDevice, PxdbDeviceState } from './pxdb-device-state';
import { initialMeshDevice, MeshDeviceState } from './mesh-device-state';
import { initialGetSubscriptionState, GetSubscriptionState } from './get-subscription-state';
import { initialStarfishDevice, StarfishDeviceState } from './starfish-device-state ';
import { TrendChannelState, initialTrendChannelsSelected } from './trend-channel-state';
import { ResetsuggestionState, initialResetSuggestion } from './reset-suggestion-state';
import { AlarmSuggestionState, initialAlarmSuggestion } from './alarm-suggestion-state';
import { SensorDetailReportState, initialSensorDetailReport } from './sensor-detail-state';
import { initialGetOrgCheckState, GetOrgCheckState } from './get-org-check-state';
import { ManageAlarmsState, initialManageAlarms } from './manage-alarms-state';
import { ManageDeviceProfilesState, initialManageDeviceProfiles } from './manage-device-profiles-state';

export type State = {
    AlarmAcknowledgement: AlarmAcknowledgementState;
    Authentication: AuthenticationState;
    Dashboard: DashboardState;
    Legal: LegalState;
    Navigation: NavigationState;
    Registration: RegistrationState;
    User: UserState;
    TimelineExport: TimelineExportState;
    SignalRConnection: SiganlRConnectionState;
    TrendExport: TrendExportState;
    router: LocationState;
    Site: SiteState;
    SierraDevice: SierraDeviceState;
    StarfishDevice: StarfishDeviceState;
    SelectedTrendChannels: TrendChannelState;
    MeshDevice: MeshDeviceState;
    GetSubscription: GetSubscriptionState;
    GetOrgCheck: GetOrgCheckState;
    AlarmSuggestion: AlarmSuggestionState;
    ResetUserSuggestion: ResetsuggestionState;
    SensorDetailReport: SensorDetailReportState;
    PxdbDevice: PxdbDeviceState;
    ManageAlarms: ManageAlarmsState;
    ManageDeviceProfiles: ManageDeviceProfilesState;
};

export const InitialState: State = {
    AlarmAcknowledgement: initialAlarmAcknowledgement,
    ResetUserSuggestion: initialResetSuggestion,
    Authentication: initialAuthenticationState,
    Dashboard: initialDashboardState,
    Legal: initialLegalState,
    Navigation: initialNavigationState,
    Registration: initialRegistrationState,
    User: initialUserState,
    TimelineExport: initialTimelineExport,
    SignalRConnection: initialSiganlRConnection,
    TrendExport: initialTrendExport,
    router: undefined,
    Site: initialSite,
    SierraDevice: initialSierraDevice,
    StarfishDevice: initialStarfishDevice,
    SelectedTrendChannels: initialTrendChannelsSelected,
    MeshDevice: initialMeshDevice,
    GetSubscription: initialGetSubscriptionState,
    GetOrgCheck: initialGetOrgCheckState,
    AlarmSuggestion: initialAlarmSuggestion,
    SensorDetailReport: initialSensorDetailReport,
    PxdbDevice: initialPxdbDevice,
    ManageAlarms: initialManageAlarms,
    ManageDeviceProfiles: initialManageDeviceProfiles,
};
